import { useRef } from 'react';

import { useTenantSecretSet } from '@/Pages/Settings/utils/useTenantSecretSet';

export const useHasWorkspaceSecrets = (apiKeys: EProviderSecretName[]) => {
  const openSecretsRef = useRef<(() => void) | null>(null);
  const secretKeys = useTenantSecretSet();

  const missingSecrets = () => {
    return apiKeys.some((i) => !secretKeys.has(i));
  };

  return { openSecretsRef, secretKeys, missingSecrets };
};

// Map of provider to secret key, non-exhaustive
export enum EProviderSecretName {
  OPENAI = 'OPENAI_API_KEY',
  ANTHROPIC = 'ANTHROPIC_API_KEY',
  AZURE_OPENAI = 'AZURE_OPENAI_API_KEY',
  GOOGLE_VERTEX_AI = 'GOOGLE_VERTEX_AI_WEB_CREDENTIALS',
  MISTRAL = 'MISTRAL_API_KEY',
  GROQ = 'GROQ_API_KEY',
}
